import { render, staticRenderFns } from "./LanguageIcon.vue?vue&type=template&id=5b7560d0&"
import script from "./LanguageIcon.vue?vue&type=script&lang=ts&"
export * from "./LanguageIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports